import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'

export default function Pairing(){
  return (
    <div className="pageStyles pairing">
      <Helmet>
        <title>Wine Pairing Events at Villaggio Grille</title>
        <meta name="description" content="Every month, Villaggio Grille hosts a wine dinner showcasing a different vineyard. With the amazing dishes they create to accompany each wine, every dinner becomes a four-course experience that your taste buds will thank you for." />
      </Helmet>

      <div className="events-listing-page custStylePTA">
        <div id="page-title" className="pt-bkg-image image-events">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="title-container less">
                  <h1>January Wine Pairing</h1>
                  <h4 className="one">
                    January 29th &nbsp;&middot;&nbsp; 6pm 
                    <span className="rules"> &nbsp;&middot;&nbsp; </span>
                    <br className="rules" />
                    $60 per guest
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container food-menus no-padding">
            <div className="intro">
              <p className="res">For Reservations: <span><PhoneLink /></span></p>
            </div>
            <div className="clearfix"></div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>
            
            <div className="course">
              <div className="service-box-2">
                <h3>Course One</h3>
                <h4>Rosemary Brie French Onion Soup</h4>
                <h5>Caramelized Onions, Beef Broth, White Wine, Topped With Baguette Slices, Creamy Brie, Rosemary</h5>
                <p>Paired with</p>
                <h4>Brocard · Bourgogne · Chardonnay '23</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Two</h3>
                <h4>Sausage &amp; Mascarpone Stuffed Portobello</h4>
                <h5>Italian Sweet Sausage, Minced Garlic, Sage, Gouda Cheese, Spinach</h5>
                <p>Paired with</p>
                <h4>Poggio Anima · Belial · Sangiovese '23</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Three</h3>
                <h4>Braised Pork Shank</h4>
                <h5>Roasted Root Vegetable Medley With Turnips, Parsnips, Onions, Cranberry Bordeaux Sauce</h5>
                <p>Paired with</p>
                <h4>Jean-Louis Chave · Côtes du Rhône · Mon Coeur '23</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Four</h3>
                <h4>Apple Cider Crème Brûlée</h4>
                <h5>Apple Cider Infused Custard, Torched Sugar, Cinnamon Whipped Cream, Fresh Apple</h5>
                <p>Paired with</p>
                <h4>Vietti · Moscato d'Asti '24</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
